import { type SelectItemEvent, selectItemEventSchema } from './eCommerceTrackingEventSchema';
import logger from '../logger';

export type SelectItemEventProps = Omit<SelectItemEvent, 'event_name' | 'event'>;

export const buildSelectItemEvent = (props: SelectItemEventProps): SelectItemEvent => {
  const { anonymousId, authenticatedId, ecommerce } = props;

  const selectItemEvent: SelectItemEvent = {
    event: 'ga4_event_ecommerce',
    event_name: 'select_item',
    anonymousId,
    authenticatedId,
    ecommerce
  };

  const result = selectItemEventSchema.safeParse(selectItemEvent);

  if (!result.success) {
    logger.error(result.error, 'Invalid select item event');
  }

  return selectItemEvent;
};
